import {ComponentRef, Injectable, ViewContainerRef} from '@angular/core';
import {VtnGenericaComponent} from '../../componentes/util/ventanas/vtn-generica/vtn-generica.component';
import {Subscription} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrearComponenteDinamicoService {
  private container!: ViewContainerRef;
  private componentes: ComponentRef<any>[] = [];

  /** Establece el contenedor donde se crearán los componentes dinámicos */
  public setContainer(container: ViewContainerRef) {
    this.container = container;
  }

  /** Crea un componente dinámico y lo almacena para control de memoria */
  public crearComponente<T>(newComponente: any): ComponentRef<T> | undefined {
    if (!this.container) {
      console.warn('Container no definido para crear componente dinámico');
      return;
    }
    // Opcional: limpiar contenedor antes de crear (si solo quieres un componente a la vez)
    // this.container.clear();

    const compRef = this.container.createComponent<T>(newComponente);

    // Almacenar referencia para destruir después
    this.componentes.push(compRef);

    // Marcar para detección de cambios si OnPush
    compRef.changeDetectorRef.markForCheck();

    return compRef;
  }

  /** Destruye un componente específico */
  public destruirComponente(compRef: ComponentRef<any>) {
    const index = this.componentes.indexOf(compRef);
    if (index !== -1) {
      compRef.destroy();
      this.componentes.splice(index, 1);
    }
  }

  /** Destruye todos los componentes dinámicos */
  public destruirTodos() {
    this.componentes.forEach(c => c.destroy());
    this.componentes = [];
    this.container?.clear();
  }

  /** Al cerrar la ventana genérica, destruye el componente dinámico raíz */
  public enlazarDestruccionAlCerrar(compRef: ComponentRef<any> | undefined, vtnGenerico: VtnGenericaComponent | undefined): void {
    if (!compRef || !vtnGenerico) {
      return;
    }
    const sub: Subscription = vtnGenerico.evtCerrarVnt.subscribe(() => {
      this.destruirComponente(compRef);
      sub.unsubscribe();
    });
  }

  /** Se asegura de limpiar memoria al destruir el servicio */
  ngOnDestroy(): void {
    this.destruirTodos();
  }

}
